import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage31.module.css";

export default function LaymanPage31() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF GEMINI</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/gimini/gemini_1img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/gimini/gemini_1img.webp`}/>
                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          Gemini's Dance: The Lightness of Syncretism in Cosmic
                          Analysis
                        </h2>
                      </div>
                      <p>
                        Gemini, a celestial archetype deeply woven into the fabric of <Link href="https://www.divineinfinitebeing.com">the
                        School of Divine Infinite Being</Link> method and Archetypal
                        Astrology, emerges as a Mutable Air Influence,
                        representing the reflective consideration of comparative
                        opposites. Beyond its astrological significance, Gemini
                        tends to be misunderstood as fleeting or misguided.
                        However, this Archetype is the formulator, engaged in
                        the profound examination of richness and worthiness in
                        one situation compared to another.
                      </p>
                      <p>
                        As a Mutable Air sign, Gemini is the butterfly that
                        flits from flower to flower, testing the pollen and
                        comparing the beauty of one bloom to the neighboring
                        garden. This Archetype revels in debate and dialectic in
                        philosophy, recognizing the utility of argument in
                        discerning relevance and necessity. Gemini is not merely
                        about weighing pros and cons but delves into the essence
                        of syncretism, identifying commonalities among seemingly
                        opposing situations.
                      </p>
                      <p>
                        The culmination of Gemini's analytical prowess is
                        encapsulated in the Thoth Arcana <span><i>"Lovers"</i></span>{" "}
                        (T-6), where Adam and Eve, representing male and female,
                        and their children Cane and Able, embodying darkness and
                        light, stand at the threshold of the chemical wedding.
                        Here, all sides are equal, comparisons are complete, and
                        the lightness of love is harmoniously balanced against
                        the commitment of marriage. The Hermit, embodying the
                        Wisdom of Mercury, officiates the wedding, symbolizing
                        Gemini's brilliance and analytical acumen{" "}
                          (both Virgo and Gemini are ruled by Mercury)
                        .
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/gimini/gemini_2img.webp"
                    /> */}
                     <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/gimini/gemini_2img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p>
                        The celebration of youth and the dance of the twins on
                        the Sun card (T-19) represents the result of this cosmic
                        marriage. The Gemini process is mirrored in its zodiacal
                        opposite, Sagittarius or Art, considered to be Gemini's
                        twin. Together, they symbolize the careful analysis and
                        synthesis process found in the prima materia of alchemy,
                        where clear analysis leads to the engagement of the
                        creative life process.
                      </p>

                      <p>
                        To work under the influence of Gemini is to suspend
                        judgments and see situations from every conceivable
                        angle. It is an invitation to open oneself to finding
                        the worth in diverse conditions, assessing their
                        equality and health. If disparities exist, Gemini
                        encourages the engagement of the analysis process with a
                        light heart and an open spirit. Embracing Gemini can
                        elevate a heavy heart, infusing laughter into the
                        gravity of life.
                      </p>
                      <p>
                        In conclusion, Gemini's dance is a cosmic ballet of
                        thoughtful analysis and syncretic insight, inviting
                        individuals to navigate the rich tapestry of existence
                        with open-mindedness and a playful spirit. As seekers
                        embrace the archetypal instinct of Gemini, they embark
                        on a journey of balanced consideration, finding the
                        worth in all facets of life's diverse conditions and
                        fostering a harmonious synthesis of opposites.
                      </p>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_cont}>
                        <p>
                          <b>Cosmic Archetype:</b> Gemini is a potent Cosmic
                          Archetype within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                          method and Archetypal Astrology, representing a
                          Mutable Air Influence.
                        </p>
                        <p>
                          <b>Mutable Air Influence:</b> Gemini is characterized
                          by its Mutable Air nature, emphasizing adaptability
                          and intellectual exploration.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/gimini/gemini_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/gimini/gemini_3img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div> */}
                      <p>
                        <b>
                          Reflective Consideration of Comparative Opposites:
                        </b>{" "}
                        Gemini embodies the reflective consideration of
                        comparative opposites, engaging in a profound analysis
                        of situations.
                      </p>

                      <p>
                        <b>Formulator:</b> Gemini is the formulator, examining
                        the richness and worthiness of one situation in
                        comparison to another, delving beyond simple pros and
                        cons.
                      </p>
                      <p>
                        <b>Syncretism:</b> Gemini represents the essence of
                        syncretism, recognizing commonalities among seemingly
                        opposing situations.
                      </p>
                      <p>
                        <b>Thoth Arcana - Lovers (T-6):</b> The culmination of
                        Gemini's analytical prowess is reflected in the Thoth
                        Tarot's <span><i>"Lovers"</i></span> (T-6), symbolizing the
                        chemical wedding where all sides are equal, and love is
                        harmoniously balanced against commitment.
                      </p>

                      <p>
                        <b>Hermit - Wisdom of Mercury:</b> The Hermit officiates
                        the wedding in the Thoth Arcana, embodying the Wisdom of
                        Mercury, highlighting Gemini's brilliance and analytical
                        acumen.
                      </p>

                      <p>
                        <b>Celebration of Youth - Sun Card (T-19):</b> The Sun
                        card (T-19) depicts the celebration of youth and the
                        dance of the twins, representing the result of the
                        cosmic marriage initiated by Gemini's analytical
                        process.
                      </p>
                      <p>
                        <b>Opposite Sign - Sagittarius or Art:</b> Gemini's
                        analytical process finds its counterpart in Sagittarius
                        or Art,{" "}
                          considered to be Gemini's twin
                        , symbolizing the careful analysis and synthesis process
                        in alchemy.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/gimini/gemini_4img.webp"
                    /> */}
                     <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/gimini/gemini_4img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Balanced Consideration:</b> Working under the
                        influence of Gemini involves suspending judgments and
                        seeing situations from various angles, promoting
                        balanced consideration.
                      </p>

                      <p>
                        <b>Open-Minded Exploration:</b> Gemini encourages
                        open-minded exploration, fostering an understanding of
                        the worth in diverse conditions and situations.
                      </p>
                      <p>
                        <b>Lightness of Spirit:</b> Embracing Gemini can lift
                        the heaviness of the heart and infuse a sense of humor
                        and lightness into life's gravity.
                      </p>

                      <p>
                        <b>Debate and Dialectic:</b> Gemini thrives in debate
                        and dialectic, recognizing the utility of argument in
                        discerning relevance and necessity.
                      </p>

                      <p>
                        <b>Richness and Worthiness Examination:</b> Gemini
                        engages in the examination of the richness and
                        worthiness of situations, evaluating them beyond
                        surface-level considerations.
                      </p>

                      <p>
                        <b>Intellectual Curiosity:</b> Individuals influenced by
                        Gemini are driven by intellectual curiosity, seeking to
                        explore and understand the complexities of life.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* className={styles.yellow_txt} */}
            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>
                      The Astrological Tarot association for Gemini is <br />{" "}
                      The Lovers. See our alchemical ROTA here
                    </h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_gemini/gemini_block1_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_gemini/gemini_block2_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_gemini/gemini_block3_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_gemini/gemini_block4_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_gemini/gemini_rota_link_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
